const defaultFilterState = {
  STARTDATE: 'Invalid date',
  ENDDATE: 'Invalid date',
  MAAKUNTA: '0',
  LAAJUUS: '0',
  TAGSEARCH: []
};

const START_DATE = 'tuko-kalenteri/filter/START_DATE';
const END_DATE = 'tuko-kalenteri/filter/END_DATE';
const MAAKUNTA = 'tuko-kalenteri/filter/MAAKUNTA';
const LAAJUUS = 'tuko-kalenteri/filter/LAAJUUS';
const TAGSEARCH = 'tuko-kalenteri/filter/TAGSEARCH';

export default function filter(state = defaultFilterState, action) {
  switch (action.type) {
    case START_DATE: {
      return Object.assign({}, state, { STARTDATE: action.filter });
    }
    case END_DATE: {
      return Object.assign({}, state, { ENDDATE: action.filter });
    }
    case MAAKUNTA: {
      return Object.assign({}, state, { MAAKUNTA: action.filter });
    }
    case LAAJUUS: {
      return Object.assign({}, state, { LAAJUUS: action.filter });
    }
    case TAGSEARCH: {
      return Object.assign({}, state, { TAGSEARCH: action.filter });
    }
    default:
      return state;
  }
}

export function filterStartDate(startDate) {
  return { type: START_DATE, filter: startDate };
}

export function filterEndDate(endDate) {
  return { type: END_DATE, filter: endDate };
}

export function filterMaakunta(maakunta) {
  return { type: MAAKUNTA, filter: maakunta };
}

export function filterLaajuus(laajuus) {
  return { type: LAAJUUS, filter: laajuus };
}

export function filterTagSearch(tags) {
  return { type: TAGSEARCH, filter: tags };
}



// WEBPACK FOOTER //
// ./src/reducers/filter.js